import React from 'react';
import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/styles/createStyles';
import makeStyles from '@material-ui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      margin: '0 -10px 32px',
      [theme.breakpoints.down('xs')]: {
        display: 'block',
        margin: '0 0 16px',
      },
    },
  }),
);

interface Props {
  children: React.ReactNode;
}

const PackageChoiceWrapper: React.FC<Props> = (props: Props) => {
  const { children } = props;
  const classes = useStyles();

  return <div className={classes.wrapper}>{children}</div>;
};

export default PackageChoiceWrapper;
